import type { AppDispatch, RootState } from '@/store';
import type { TypedUseSelectorHook } from 'react-redux';
import { useDispatch, useSelector } from 'react-redux';

export * from './useAuth';
export * from './useStores';
export * from './useGeocoder';
export * from './useGeocoding';
export * from './usePasswordFeedback';
export * from './useStickyHeader';
export * from './useUser';
export * from './useFetchTrackingInfo';
export * from './useFetchUser';

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
